import React from 'react';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Box, TabsProps } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import { purple } from 'globals/colors';

export const FsTabsContainer = withStyles(({ spacing }: Theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: spacing(2),
  },
}))((props) => <Box {...props} />);

export interface FsTabsProps extends Pick<TabsProps, 'variant'> {
  value: number;
  onChange: (
    event: React.ChangeEvent<Record<string, unknown>>,
    newValue: number
  ) => void;
}

export const FsTabs = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        bottom: 2,
        left: 0,
        width: '100%',
        height: 1,
        display: 'block',
        backgroundColor: purple.V4,
      },
    },
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      '& > span': {
        width: '100%',
        height: 6,
        backgroundColor: palette.primary.main,
        borderRadius: 3,
        transform: 'translate(0,-4px)',
      },
    },
  })
)((props: FsTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
));
